<!-- <section class="w-full mx-auto dark:bg-gray-900 dark:text-white">
    <div class="container px-4">
        <div class="flex flex-wrap">
            <div class="w-full px-4">
                <div class="text-center mx-auto mb-12 max-w-2xl">
                    <h2 class="font-bold text-3xl pt-10 sm:text-4xl md:text-[40px] text-dark mb-4">
                        What We Offer
                    </h2>
                    <p class="text-base text-body-color">
                        Discover exclusive travel deals, personalized packages, and expert assistance to make your
                        journeys seamless and unforgettable. Whether you're looking for discounted flights, luxury
                        cruises, or 24/7 travel support, we have everything you need to explore the world with ease.
                    </p>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap px-4">
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:airplane_ticket"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Discounted Flights
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Enjoy unbeatable airfare deals to top destinations worldwide.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8"
                                svgIcon="heroicons_mini:globe-europe-africa"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Exclusive Travel Specials
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Access limited-time offers and vacation packages tailored for you.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:beach_access"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Tour Packages
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Plan your dream getaway with personalized itineraries and experiences.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:directions_boat"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Luxury Cruises
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Set sail on world-class cruises with exclusive onboard perks and savings.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:headphones_battery"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            24/7 Travel Support
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Get expert support anytime, anywhere for a stress-free journey.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:home_work"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Hotel & Car Rental
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Save on accommodations and transportation for a seamless.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="w-full mx-auto dark:bg-gray-900 dark:text-white" [ngClass]="view.site?.id === 72 ? 'border-b-2 border-primary-500' : ''">
    <div class="container px-4">
        <div class="flex flex-wrap">
            <div class="w-full px-4">
                @if(view.site?.id == 77) {
                <div class="text-center mx-auto mb-12 max-w-2xl">
                    <h2 class="font-bold text-3xl pt-10 sm:text-4xl md:text-[40px] text-dark mb-4">
                        Why Choose Us?
                    </h2>
                </div>
                }
                @if(view.site?.id == 72) {
                <div class="text-center mx-auto mb-12 max-w-2xl">
                    <h2 class="font-bold text-3xl pt-10 sm:text-4xl md:text-[40px] text-dark mb-4">
                        More than just Bookings — We’re Your Travel Partner
                    </h2>
                    <p class="text-base text-body-color">
                        <b>We don’t just sell holidays. We create experiences.</b><br><br>
                        Whether you’re dreaming of Mauritius beaches, a European river cruise, a bush break, or your
                        favourite sports
                        team’s next away match—we’re here to bring those plans to life. From family holidays,
                        honeymoons, and group
                        trips to luxury escapes, ski adventures, and city breaks—we’ve done it all, and we love doing
                        it.
                    </p>
                </div>
                }
                @if(view.site?.id != 72 && view.site?.id != 77) {
                <div class="text-center mx-auto mb-12 max-w-2xl">
                    <h2 class="font-bold text-3xl pt-10 sm:text-4xl md:text-[40px] text-dark mb-4">
                        What We Offer
                    </h2>
                    <p class="text-base text-body-color">
                        Discover exclusive travel deals, personalized packages, and expert assistance to make your
                        journeys seamless and unforgettable. Whether you're looking for discounted flights, luxury
                        cruises, or 24/7 travel support, we have everything you need to explore the world with ease.
                    </p>
                </div>
                }
            </div>
        </div>

        @if(view.site?.id != 72 && view.site?.id != 77){
        <div class="flex flex-wrap px-4">
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:airplane_ticket"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Flights
                        </h4>
                    </div>
                    <p class="text-body-color">
                        providing expert assistance in booking flights and ensuring you find the best deals for your
                        desired destinations
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="heroicons_outline:home-modern"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Accommodation
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Unlock your dream accommodations effortlessly with our travel agency's seamless reservation
                        services
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_solid:car_rental"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Car Hire
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Providing you with the perfect vehicle to embark on unforgettable adventures and discover hidden
                        gems at your own pace
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="heroicons_outline:credit-card"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Visa Assistance
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Providing guidance and support to help you obtain the necessary documents for your international
                        travels
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8"
                                svgIcon="heroicons_outline:document-text"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Travel Insurance
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Relax and enjoy your trip without worry thanks to our all-inclusive travel insurance
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:beach_access"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Tour Packages
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Our tour packages are designed to immerse you in the beauty, culture, and wonders of
                        destinations around the world
                    </p>
                </div>
            </div>
        </div>
        }
        @if(view.site?.id == 72){
        <div class="flex flex-wrap px-4">
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:airplane_ticket"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Flights & Accommodation
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Seamless booking of flights and handpicked stays to match your travel needs.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="heroicons_outline:home-modern"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Guided Coach Tours & City Stays
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Explore top destinations with expert guides and comfortable city accommodations.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_solid:car_rental"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Cruises & cultural getaways
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Unpack once and experience multiple destinations with enriching cultural excursions.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="heroicons_outline:credit-card"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Incentive & group travel
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Customized packages for corporate rewards, events, and group adventures.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8"
                                svgIcon="heroicons_outline:document-text"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Honeymoon & Anniversary Packages
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Romantic, stress-free escapes crafted for unforgettable milestones.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:beach_access"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Tailored Travel Planning & Support
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Personalized itineraries with dedicated support every step of the way.
                    </p>
                </div>
            </div>
        </div>
        }
        @if(view.site?.id === 77) {
        <div class="flex flex-wrap px-4">
            <div class="w-full md:w-1/2 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="mat_outline:contact_phone"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Personalized Service
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Work directly with an experienced travel professional who takes the time to understand your
                        needs.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="heroicons_outline:gift-top"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Competitive Deals
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Being part of the XL Travel Group, we have access to great specials, negotiated rates, and the
                        latest travel promotions.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="support_agent"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Reliable Support
                        </h4>
                    </div>
                    <p class="text-body-color">
                        From your first inquiry until you return home, I’m just a phone call or message away.
                    </p>
                </div>
            </div>
            <div class="w-full md:w-1/2 px-4">
                <div class="p-5 md:px-7 xl:px-10 rounded-[20px] bg-white shadow-md hover:shadow-lg mb-8 h-44">
                    <div class="flex items-center justify-start mb-3">
                        <div class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl">
                            <mat-icon class="text-white icon-size-8" svgIcon="heroicons_outline:credit-card"></mat-icon>
                        </div>
                        <h4 class="ml-5 font-semibold text-lg text-dark">
                            Attention to Detail
                        </h4>
                    </div>
                    <p class="text-body-color">
                        Every booking, big or small, is handled with care and precision.
                    </p>
                </div>
            </div>
        </div>
        }
    </div>
</section>